module.exports = __webpack_public_path__ + "img/wave_qr_code.4092d7eb.jpg";